import { render, staticRenderFns } from "./typesList.vue?vue&type=template&id=d4da04f8&scoped=true&"
import script from "./typesList.vue?vue&type=script&lang=js&"
export * from "./typesList.vue?vue&type=script&lang=js&"
import style0 from "./typesList.vue?vue&type=style&index=0&id=d4da04f8&lang=scss&scoped=true&"
import style1 from "./typesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4da04f8",
  null
  
)

export default component.exports